<template>
  <div class="index bg-white pad12-t index-sd">
    <!-- search -->
    <!-- <van-sticky></van-sticky> -->
    <div class="pad12" @click="routerClick('mob/goods/searchPage.do?isAllSearch=1&areaAxis=%241100', 'sc')">
      <Search :text= searchText />
    </div>
    <!-- guide -->
    <div class="pad12-b pad12-lr guide">
      <ul class="flex items-center justify-between">
        <li
          class="flex flex-column items-center justify-center relative"
          v-for="item in guide" :key="item.name"
          @click="routerClick(item.url,item.type,item.isLogin)">
          <span class="white f10 radius30 absolute mark" v-if="countCart && item.isMark">{{ countCart }}</span>
          <img :src="item.icon" />
          <span class="f12 white">{{item.name}}</span>
        </li>
      </ul>
    </div>
    <van-pull-refresh v-model="loading" @refresh="onRefresh">
      <!-- swipe -->
    <div class="pad12-b pad12-lr swipe">
      <van-swipe :autoplay="3000" lazy-render>
        <van-swipe-item v-for="(item, index) in swipeList" :key="index" @click="routerClick(item.url,'link')">
          <van-image lazy-load :src="`${item.img}?imageView2/1/w/700/h/280`" />
        </van-swipe-item>
      </van-swipe>
    </div>
    <!-- recommend v-if="userInfo.id" -->
    <div class="pad12-lr recommend">
      <div class="flex items-center pad5-b">
        <ul class="flex-auto floor-list">
          <li
            class="pad10-lr pad5-tb f15 gray9 relative"
            :class="{active: item.id === recommendId}"
            v-for="(item) in recommend.floorList" :key="item.id"
            @click="recommendChoose(item.id)">
            {{ item.name }}
          </li>
        </ul>
      </div>
      <!-- 优品 -->
      <template v-if="recommendId === 'good' && recommendGood.length">
        <van-list
          :loading="goodLoaing"
          :finished="goodFinished"
          :offset="10"
          finished-text="已经到底了"
          @load="onLoadGood">
          <SDGoodList :goodList= recommendGood @getCountCart="getCountCart" />
        </van-list>
      </template>
      <!-- 好店 -->
      <template v-if="recommendId === 'shop' && recommendShop.length">
        <van-list
          :loading="shopLoaing"
          :finished="shopFinished"
          :offset="10"
          finished-text="已经到底了"
          @load="onLoadShop">
          <div class="shopList">
            <ul class="shop-list" v-for="shop in recommendShop" :key="shop.shopIds">
              <li class="flex bg-white radius5 mar10-t">
                <div class="shop-img flex-shrink">
                  <van-image lazy-load class="radius5-t" :src="`${shop.face}?imageView2/1/w/200/h/260`" />
                </div>
                <div class="pad10 flex flex-auto flex-column justify-between">
                  <div class="flex items-center justify-between">
                    <div class="flex-auto">
                      <p class="black f13 text-overflow">{{ shop.name }}</p>
                    </div>
                    <div class="flex-shrink f12 white pad10-lr shop-btn radius30" @click="routerClick(`/shop/${shop.shopIds}`)">进店</div>
                  </div>
                  <div>
                    <van-rate :size="8" v-model="shop.level" color="#FE5603" void-color="#ddd" readonly  />
                  </div>
                  <p class="f12 gray9 text-overflow">主营:{{ shop.businesScope }}</p>
                  <p class="f12 gray9 text-overflow">地址:{{ shop.areaName }}{{ shop.addr }}</p>
                </div>
              </li>
            </ul>
          </div>
        </van-list>
      </template>
    </div>
    </van-pull-refresh>
    <div class="footer_iphone bg-grayf2"></div>
    <!-- 购物车悬浮图标 -->
    <div class="shop-cart text-right pad5-t pad5-r" @click="routerClick('/cart', '', 1)">
      <span class="white f10 radius30" v-if="countCart">{{ countCart }}</span>
    </div>
  </div>
</template>
<script>
import jsonp from "jsonp";
import { Toast } from "vant";
import { mapState } from "vuex";
import Search from "@/components/search";
import common from "../../assets/js/common";
import SDGoodList from "./components/sdGoodList";

export default {
  components: {
    Search,
    SDGoodList
  },
  data() {
    return {
      loading: false,
      searchText: "输入货品或店铺名称",
      origin: process.env,
      countCart: 0,
      swipeList: [], // 广告轮播图列表
      guide: [
        {
          icon: "https://cmscenter-files.nxin.com/nxsc/sd-index/guide/cart.png",
          name: "进货车",
          url: "/cart",
          type: "",
          isLogin: true,
          isMark: true
        },
        {
          icon: "https://cmscenter-files.nxin.com/nxsc/sd-index/guide/collect.png",
          name: "收藏",
          url: "mob/member/favorite/listPage.do?type=1",
          type: "sc",
          isLogin: true
        },
        {
          icon: "https://cmscenter-files.nxin.com/nxsc/sd-index/guide/coupon.png",
          name: "优惠券",
          url: "cashCoupon/mob/toPage",
          type: "sc",
          isLogin: true
        },
        {
          icon: "https://cmscenter-files.nxin.com/nxsc/sd-index/guide/address.png",
          name: "收货地址",
          url: "mob/member/delivery/deliveryList.do",
          type: "sc",
          isLogin: true
        },
        {
          icon: "https://cmscenter-files.nxin.com/nxsc/sd-index/guide/order.png",
          name: "我的订单",
          url: "mob/order/person/orderListNew?type=0",
          type: "sc",
          isLogin: true
        }
      ],
      recommend: {
        name: "为您推荐",
        floorList: [
          {
            id: "good",
            name: "优选商品"
          },
          {
            id: "shop",
            name: "精选好店"
          }
        ]
      },
      recommendId: "good", // 为你推荐选中的id
      recommendGood: [],
      goodNum: 1,
      goodTotal: 0,
      goodLoaing: false,
      goodFinished: false,
      recommendShop: [],
      shopNum: 1,
      shopTotal: 0,
      shopLoaing: false,
      shopFinished: false,
      isShow: false,
      video: { // 视频播放相关参数
        url: "",
        cover: "",
        muted: false,
        loop: true,
        preload: "auto",
        poster: "",
        volume: 1,
        autoplay: true
      }
    };
  },
  computed: mapState({
    userInfo: state => state.app.userInfo,
    userIdentity: state => state.app.userIdentity
  }),
  created() {
    console.log("用户信息userIdentity", this.userIdentity);
    Toast.loading({
      mask: true,
      message: "加载中...",
      duration: 2000
    });
    this.init();
  },
  methods: {
    onRefresh() {
      this.shopNum = 1;
      this.goodNum = 1;
      setTimeout(() => {
        Toast.success("刷新成功");
        this.loading = false;
        this.init();
      }, 1000);
    },
    init() {
      this.getSwipe();
      // this.getRecommend('good');
      this.getSearchGoods();
      this.queryShopList();
      if (this.userInfo.id) {
        this.getCountCart();
      }
    },

    // 查询购物车数量
    getCountCart() {
      this.$store.dispatch("member/member/getCountCart", this.$qs.stringify({})).then((data) => {
        const num = data || 0;
        this.countCart = num > 99 ? "99+" : num;
      });
    },

    // 获取广告轮播图
    getSwipe() {
      const url = "https://graphicinformation.nxin.com/getJsonFormatAdList/282";
      jsonp(url, (err, res) => {
        console.log(err);
        this.swipeList = res || [];
      });
    },

    // 推荐商品
    getSearchGoods() {
      const conditionJSON = {
        pageNum: this.goodNum,
        pageSize: 30,
        areaAxis: "$1100",
        isAllSearch: "1"
      };
      this.$store.dispatch("index/getSearchGoods", {
        conditionJSON: JSON.stringify(conditionJSON)
      }).then((data) => {
        const goodList = data.list || [];
        const total = data.listSize || 0;
        goodList.forEach((item) => {
          const price = item.marketPriceStr.split(".");
          item.price = price;
        });
        this.recommendGood = [...this.recommendGood, ...goodList];
        console.log("getSearchGoods", this.recommendGood);
        this.goodTotal = Math.ceil(total / 10);
        this.goodLoaing = false;
        if (this.goodNum >= this.goodTotal) {
          this.goodFinished = true;
        }
      });
    },
    onLoadGood() {
      const { goodNum, goodTotal, recommendGood } = this;
      if (goodNum > goodTotal || !recommendGood.length) { return; }
      this.goodNum += 1;
      this.goodLoaing = true;
      this.getSearchGoods();
    },

    // 推荐店铺
    queryShopList() {
      const conditionJSON = {
        pageNum: this.shopNum,
        pageSize: 10,
        areaAxis: "$1100",
        isAllSearch: "1"
      };
      this.$store.dispatch("index/queryShopList", {
        conditionJSON: JSON.stringify(conditionJSON)
      }).then((res) => {
        console.log("queryShopList", res);
        const shopList = res.list || [];
        const total = res.shopCount || 0;
        this.recommendShop = [...this.recommendShop, ...shopList];
        this.shopTotal = Math.ceil(total / 10);
        this.shopLoaing = false;
        if (this.shopNum >= this.shopTotal) {
          this.shopFinished = true;
        }
      });
    },
    onLoadShop() {
      const { shopNum, shopTotal, recommendShop } = this;
      if (shopNum > shopTotal || !recommendShop.length) { return; }
      this.shopNum += 1;
      this.shopLoaing = true;
      this.queryShopList();
    },
    // 推荐切换
    recommendChoose(id) {
      this.recommendId = id;
    },

    // 获取活动
    getActivity() {
      this.$store.dispatch("index/getActivityCode").then((res) => {
        const activityCode = res;
        if (!res) {
          return;
        }
        this.$store.dispatch("channel/getActivityFloorList", activityCode).then((data) => {
          console.log("活动楼层", data);
          if (!data) {
            return;
          }
          //  isExistData：是否展示楼层 0：不展示 1：展示
          const { customPageFloorList } = data;
          this.floorList = customPageFloorList.filter(item => item.isExistData);
          console.log("floorList", this.floorList);
          this.floorList.forEach((item, index) => {
            item.subIndex = 0;
            const { id, recommendType } = item.subFloorList[0];
            this.floorType = recommendType;
            this.getGoodList(id, index, item.subIndex, recommendType);
          });
        });
      });
    },

    // 点击跳转
    routerClick(url, type, isLogin) {
      if (!url) {
        return;
      }
      if (isLogin && !common.isLogin(this.userInfo.id)) {
        return;
      }
      if (type === "link") {
        window.location.href = url;
      } else if (type === "hl") {
        window.location.href = `${this.origin.VUE_APP_HL}${url}`;
      } else if (type === "sc") {
        window.location.href = `${this.origin.VUE_APP_APP}${url}`;
      } else {
        this.$router.push(url);
      }
    },

    // 去登录
    toLogin() {
      if (!common.isLogin(this.userInfo.id)) {
        console.log("去登录");
      }
    },

    // 获取企业列表
    getEnterpriseList() {
      this.$store.dispatch("order/confirmOrder/getEnterpriseList").then((res) => {
        const { data } = res;
        this.entList = data || [];
        console.log("企业列表", data);
        const {
          id, image, realName, mobilePhone
        } = this.userInfo;
        const user = {
          ID: id,
          Name: realName,
          Logo: image,
          isUser: true
        };
        if (this.entList.some(item => item.IsDefault)) {
          this.entList.splice(1, 0, user);
          console.log(user);
        } else {
          this.entList.unshift(user);
        }
        this.entAllList = this.entList;
        console.log("this.entList", this.entList);
        this.defaultEnt = {
          ID: this.entList[0].ID,
          Name: this.entList[0].Name,
          Logo: this.entList[0].Logo,
          phone: mobilePhone,
          isUser: this.entList[0].isUser || false
        };
      });
    },
    // 切换身份
    updateEnterprise(id) {
      if (id === this.defaultEnt.ID) {
        this.chooseEntShow = false;
        return;
      }
      this.$store.dispatch("order/confirmOrder/updateEnterprise", { enterpriseId: id }).then(() => {
        Toast.loading({
          mask: true,
          message: "加载中...",
          duration: 1000
        });
        this.init();
        this.chooseEntShow = false;
      });
    },
    entListUpdate() {
      let searchEntList = [];
      searchEntList = this.entAllList.filter(item => item.Name.indexOf(this.entSearch) !== -1);
      console.log(searchEntList);
      this.entList = searchEntList;
    },

    getLocation() {
      const that = this;
      if (common.isInWeiXin()) {
        // 微信环境下获取有延迟
        setTimeout(() => {
          wx.getLocation({
            type: "wgs84", // 默认为wgs84的gps坐标，如果要返回直接给openLocation用的火星坐标，可传入'gcj02'
            success(res) {
              const { latitude, longitude } = res;
              console.log("微信获取经纬度", res);
              that.lat = latitude;
              that.lon = longitude;
              this.getYyzx();
            },
            fail(res) {
              console.log("微信获取经纬度失败", res);
            }
          });
        }, 500);
      }
    }
  }
};
</script>


<style lang="scss" scoped>
  @import './style.scss';
</style>
